import { render, staticRenderFns } from "./GGrid.vue?vue&type=template&id=484858ae&"
import script from "./GGrid.vue?vue&type=script&lang=js&"
export * from "./GGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports